import styled from 'styled-components';

export const ErrorContainer = styled.section`
  z-index: 999;
  background-image: radial-gradient(circle at 50% 40%, #5d6480, #4e546b);
  height: 100%;
  position: relative;
`;

export const MsgContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding: 15px 0;
`;

export const SubText = styled.span`
  width: 37.8rem;
  min-height: 2.806rem;
  font-size: 2.0666rem;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${({ theme }) => theme.white.a10};
  margin-top: 2rem;
  margin-bottom: 4rem;
`;
